import getLectureList from "./getLectureList";
import getLecture from "./getLecture";

export default { getLectureList, getLecture };
